import { render, staticRenderFns } from "./testimonials.vue?vue&type=template&id=778d65d1"
import script from "./testimonials.vue?vue&type=script&lang=js"
export * from "./testimonials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Testimonial: require('/vercel/path0/components/testimonial.vue').default,Slider: require('/vercel/path0/components/ui/slider.vue').default,Link: require('/vercel/path0/components/ui/link.vue').default})
